import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Button, { type ButtonProps } from "@mui/material/Button";
import { useTranslation } from "react-i18next";

export function ResetButton({ children, ...props }: ButtonProps) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:ResetButton",
  });
  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<RestartAltIcon />}
      {...props}
    >
      {children ?? t("buttonText")}
    </Button>
  );
}
